/* eslint-disable react/prop-types */
import React from 'react';
import sc from 'styled-components';
import { Avatar, Menu, Dropdown, Button } from 'antd';

const StyledUserProfile = sc.div`
  margin-left: auto;
  right: 0;
  padding-top: 4px;
  & > .ant-btn {
      border: none;
      color: #999999;
      box-shadow: none;
    &:hover {
        color: rgb(0,121,191);
      }
  }
`;

const menu = ({ profile, login, logout }) => (
  <Menu>
    <Menu.Item disabled>
      {profile && <span>{ profile.email || profile.name || '??'}</span>}
    </Menu.Item>
    <Menu.Divider />
    <Menu.Item>
      {profile ? <a onClick={logout}>Sign Out</a> : <a onClick={login}>Sign in</a>}
    </Menu.Item>
  </Menu>
);

export default (props) => (
  <StyledUserProfile className="user-profile">
    <Dropdown overlay={menu(props)} placement="bottomRight">
      <Button><Avatar icon="user" /></Button>
    </Dropdown>
  </StyledUserProfile>
);
